import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PDPContext } from '../../context';
import { UIContext } from '../../shared/UIContext/UIContext';
import { EU_REGULATIONS, REGULATIONS_ALT_DESCRIPTOIN, CNET_CHARGING_PICTOGRAM } from '../../constants';
import { t } from '@insight/toolkit-utils'
import { SpecificationsTechOverview as PDPSpecificationsTechOverview } from '@insight/toolkit-react';

export const SpecificationsTechOverview = () => {
  const { product } = useContext(PDPContext);
  const { scrollIntoView } = useContext(UIContext);
  const [EURegulationsImage, setEURegulationsImage] = useState(null)
  const history = useHistory();
  const isEURegulations = window?.flags?.[EU_REGULATIONS]
  const flatProductImages = [];

  useEffect(()=> {
    try {
      product?.images?.map(imageLevel1 =>
          Object.values(imageLevel1?.images)?.map(imageLevel2 =>
              imageLevel2?.map(imageLevel3 => flatProductImages.push(imageLevel3))
          )
      );

      const res = flatProductImages.filter(image => image.type === CNET_CHARGING_PICTOGRAM)?.[0];
      setEURegulationsImage(res);
      } catch (error) {
          console.error("An error occurred while processing images:", error);
      }
  }, [])

  return <PDPSpecificationsTechOverview
    description={product?.descriptions?.longDescription}
    scrollIntoView={scrollIntoView}
    history={history}
    isEURegulations={isEURegulations}
    EURegulationsImage={EURegulationsImage}
    altDescription={t(REGULATIONS_ALT_DESCRIPTOIN)}
  />
}

export default SpecificationsTechOverview;
